import * as React from 'react'
import { useSearchParams } from 'react-router-dom'

import { formatNumber } from '../../../util'
import { ColumnId, OptionsQuery } from '../types'
import { FilterSelect } from './FilterSelect'

export function StrikeFilter({ currentStrike, strikes }: { currentStrike: number; strikes: number[] }) {
  const [, setSearchParams] = useSearchParams()

  const filterOptions = React.useMemo(
    () => strikes.map((option) => ({ label: '$ ' + formatNumber(option), value: option })),
    [strikes]
  )

  return (
    <FilterSelect
      filterColumn={ColumnId.StrikePrice}
      selected={currentStrike}
      options={filterOptions}
      onChange={(option) => {
        setSearchParams((prev) => {
          const newQuery = new URLSearchParams(prev)
          newQuery.set(OptionsQuery.Strike, option.value.toString())
          return newQuery
        })
      }}
    />
  )
}
